
import { getSVGIcon } from "~/functions"
import { Operator } from "~/types/operator"

export const oryx: Operator = {
	id: 'oryx',
	name: 'Oryx',
	role: 'Defender',
	org: 'UNAFFILIATED',
	squad: 'REDHAMMER',
	ratings: {
		health: 2,
		speed: 2,
		difficulty: 2
	},
	meta: {
		gender: 'm',
		country: 'jo',
		season: 'Y5S1',
		height: 195,
		weight: 130,
		price: {
			renown: 10000,
			r6credits: 240
		}
	},
	bio: {
		real_name: 'Saif Al Hadid',
		birthplace: 'Azraq, Jordan'
	},
	svg: {
		contents: '<switch><foreignObject width="1" height="1" x="0" y="0" requiredExtensions="http://ns.adobe.com/AdobeIllustrator/10.0/"></foreignObject><g><path d="M45 45h260v260H45z" style="opacity:.4"></path><path d="M277 277H73v-5.278a14708 14708 0 0 1 63.833-4.243L73 261.5V229l39.889-2.722L73 222.611v-111.5a810 810 0 0 0 56.948-2.84L73 102.91V88.333L136.778 84 73 77.778V73h204z" style="fill:#8c638c"></path><path d="M277 73v117.375l-32.958 1.75-26.25 24.958-2.167 26.125c8.03 22.654 13.218 39.403 13.042 41.903a10 10 0 0 1-.578 2.655c-.562 1.429-1.395 2.384-2.131 3.227a16.7 16.7 0 0 1-2.514 2.34l-6.101 4.7a6 6 0 0 0-.786.733c-.247.276-.427.478-.568.787-.09.197-.12.341-.211 1.058-.136 1.062-.122 1.146-.194 1.444a4.5 4.5 0 0 1-.438 1.111c-3.037 2.533-8.144 6.006-15.035 7.417a34 34 0 0 1-7 .667c-3.502-.026-7.259-.054-11.236-2-6.398-3.131-9.887-9.525-10.417-11.917-.079-.358-.379-1.918-1.287-3.801a16 16 0 0 0-1.004-1.783l-18.083-28.556 60.083-3.528-64.958-3.75c-5.364-8.948-9.86-15.316-11.801-17.383a19.6 19.6 0 0 0-3.241-2.756c-1.295-.837-2.042-1.056-3.048-1.566-2.113-1.071-3.328-2.394-5.507-4.768-1.605-1.749-3.076-3.351-4.421-5.831-.917-1.692-2.19-4.559-2.649-8.488-17.149-16.101-30.15-31.356-39.597-43.625-14.096-18.306-22.768-33.197-25.111-37.278-2.372-4.131-8.839-15.615-15.621-31.101-5.187-11.844-7.87-19.893-8.879-23.01-2.143-6.617-3.739-11.611-4.988-18.639-.952-5.353-1.526-10.896-2.157-16.992a407 407 0 0 1-.826-8.924c11.148 21.235 25.105 43.61 42.681 65.986a425 425 0 0 0 10.667 13.042l-4.653-9.306-8.181-22.986a170.4 170.4 0 0 1-1.764-25.958c.046-1.461.133-3.507.31-5.948.104-1.435.32-4.126 1.079-10.163.362-2.878.853-6.57 1.5-10.889a545 545 0 0 0 4.125 14.312c1.907 6.294 6.994 23.078 13.542 39.243 6.116 15.099 17.989 43.753 42.778 72.667a226 226 0 0 0 9.778 10.694l7.833 4.194 66.333-.833-64.778-3.111 1.879-5.448c.079-.215.254-.783.083-1.479a2.58 2.58 0 0 0-.865-1.365l-19.542-15.986-3.889-23 20.667 1.222L154.5 136a14.8 14.8 0 0 1 1.555 3l2.778.889 6.333-6.056 83.056-2.667-76.778-4.556a169 169 0 0 1 9.309-7.814c4.845-3.781 7.806-5.671 15.163-10.908a701 701 0 0 0 11.083-8.056l65.111-2.278-56.389-5.111a224 224 0 0 1 13.111-7 225 225 0 0 1 30.889-12.444z"></path><path d="m156 205.958 9.25 28.917 7.664-15.286zm-8.521-66.396-11.417-11.083-9.896-1.292 1.396 9.958 17.625 13.542zM37.25 84.25a264.6 264.6 0 0 0 16.306 36.861c1.796 3.345 6.161 11.304 13.333 22.167 8.57 12.978 22.34 31.908 43.111 53.931.967.035 10.744.223 16.667-7.653 3.975-5.285 3.853-11.063 3.75-12.806a261 261 0 0 1-10.694-6.806s-9.505-6.377-18.278-13.444c-16.363-13.183-30.119-28.783-35.611-35.056A369 369 0 0 1 37.25 84.25" style="fill:#fff"></path></g></switch>',
		attributes: {
			xmlns: 'http://www.w3.org/2000/svg',
			space: 'preserve',
			viewBox: '0 0 350 350',
			class: 'r6operators r6operators-oryx'
		}
	},
	toSVG: function(userAttr){return getSVGIcon(this, userAttr)}
}
